import { findHeightPosition } from '~/utils/findPosition';

export default function currentPosition(element: React.MutableRefObject<HTMLDivElement>) {
  return findHeightPosition(element.current) - element.current?.getBoundingClientRect().height;
}
